import React, { useEffect, useState, useCallback } from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import * as BatchServices from "../../../../services/BatchService";
import { useTranslation } from "react-i18next";
import BatchForm from "./batchForm.view";
import PATHS from "../../../../constants/paths";
import {
  BreadCrumb,
  ShowAlertDialog,
} from "@de-prado-dev/react-component-library";

const BatchFormContainer = ({ uuid }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [initValues, setInitValues] = useState({});

  const setInitialValues = useCallback(async (data) => {
    const dataFinal = {
      code: data.code,
      active: data.active,
    };
    setInitValues(dataFinal);
  }, []);

  const loadData = useCallback(async () => {
    if (uuid) {
      const result = await BatchServices.getBatch(uuid);
      if (result) {
        await setInitialValues(result);
      }
    }
  }, [setInitialValues, uuid]);

  useEffect(() => {
    loadData();
  }, []);

  const handleSubmit = async (values) => {
    try {
      if (values) {
        let result = undefined;

        if (uuid) {
          result = await BatchServices.updateBatch(values, uuid);
        } else {
          result = await BatchServices.addBatch(values);
        }

        let title = "";
        let text = "";
        let icon = "";
        if (result) {
          if (uuid) {
            title = t("forms.batch.messages.update.title");
            text = t("forms.batch.messages.update.success");
            icon = "success";
          } else {
            title = t("forms.batch.messages.create.title");
            text = t("forms.batch.messages.create.success");
            icon = "success";
          }
        } else {
          title = "Error";
          text = t("forms.batch.messages.update.error");
          icon = "error";
        }

        let okAction = () => {
          navigate(PATHS.BATCH_LIST);
        };
        ShowAlertDialog(title, text, icon, false, "OK", false, okAction);
      }
    } catch (error) {
      //console.log('Error', error);
    }
  };

  const handleOnback = () => {
    navigate(PATHS.BATCH_LIST);
  };

  return (
    <BatchForm
      edit={uuid ? true : false}
      initialValues={initValues}
      onSubmit={handleSubmit}
      onback={handleOnback}
    />
  );
};

BatchFormContainer.propTypes = {
  t: PropTypes.any,
};

export default BatchFormContainer;
